import { EventSlide } from '../../../../../models/slides/EventSlide';

export const getEventSlide = (eventElement: EventSlide) => {
  const updatedEvent = {
    image: eventElement?.image || '',
    type: 'EVENT',
    title: eventElement?.title || '',
    description: eventElement?.description || '',
    id: eventElement?.id || 0,
    dateFrom: eventElement?.dateFrom || null,
    dateTo: eventElement?.dateTo || null,
    organizer: eventElement?.organizer || '',
    location: eventElement?.location || [],
    ticketPrices: eventElement?.ticketPrices || [],
    animalFriendly: eventElement?.animalFriendly || null,
    disabledFriendly: eventElement?.disabledFriendly || null,
  };

  return updatedEvent;
};
